import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useMediaQuery } from "react-responsive";
import { BrowserStorage, CasAuthApi, User } from "@jti/rest-api";
import { UserIndicationButton, } from "./components/UserIndicationButton/UserIndicationButton";
export const UserActions = ({ tabletUserNameRef, isEnabledUserIndication, isEnabledUserNameForIndication, ...props }) => {
    const [isUserLoggedIn, setUserLoggedIn] = useState(false);
    const validateUserSession = useCallback(async () => {
        const user = new User(new BrowserStorage());
        const userData = user.getUser();
        if (userData.ciam_token) {
            const { statusCode } = await CasAuthApi.init().validate(userData.ciam_token, true);
            const isValidSession = statusCode === 200 || statusCode === 204;
            setUserLoggedIn(isValidSession);
            if (!isValidSession) {
                user.clearUser();
            }
        }
    }, []);
    useEffect(() => {
        validateUserSession();
    }, [validateUserSession]);
    const MEDIUM_WIDTH = 1280;
    const SMALL_WIDTH = 768;
    const isBelowDesktopBreakpoint = useMediaQuery({
        query: `(min-width: ${SMALL_WIDTH}px) and (max-width: ${MEDIUM_WIDTH - 1}px)`,
    });
    const userActionElement = (_jsx(UserIndicationButton, { isEnabledUserIndication: isEnabledUserIndication, isEnabledUserNameForIndication: isEnabledUserNameForIndication, isUserLoggedIn: isUserLoggedIn, ...props }));
    if (isUserLoggedIn && isEnabledUserIndication && isEnabledUserNameForIndication && isBelowDesktopBreakpoint) {
        if (tabletUserNameRef.current) {
            return createPortal(userActionElement, tabletUserNameRef.current);
        }
    }
    return userActionElement;
};
//# sourceMappingURL=UserActions.js.map